<template>
  <div>
      <blockquote>
        <template
          v-for="(cont, i) in content"
        >
          <Paragraph
            :content="cont.content"
            v-if="cont.type === 'paragraph'"
            :key="`list-paragraph-${i}`"
          />
        </template>
      </blockquote>
  </div>
</template>

<script>

import Paragraph from '@/components/post/Blocks/Paragraph.vue'

export default {
  name: 'Blockquote',
  props: ['content'],
  components: {
    Paragraph
  }
}
</script>

<style lang="scss" scoped>
/* BLOCKQUOTE */
::v-deep {
  blockquote{
    border-left: 3px solid rgba(0,0,0,.1);
    color: rgba(0,0,0,.8);
    padding-left: .8rem;
    font-style: italic;

    p{
        margin: 0;
    }
  }
}
</style>
